.tabbable {
	display: flex;
	flex-direction: column;
	width: 100%;

	.tablist {
		display: flex;
		border-bottom: 2px solid #ccc;

		> button {
			flex: 1;
			font-weight: 500;
			padding: 0.5rem 1rem;
			position: relative;

			&::after {
				content: "";
				position: absolute;
				left: 50%;
				bottom: -1px;

				width: 100%;
				height: 4px;

				background: var(--primary);

				transform: translateX(-50%) scaleX(0);
				transform-origin: center;
				transition: transform 0.2s ease;
			}

			&.active {
				color: var(--primary);
				transition: color 0.2s ease;

				&::after {
					transform: translateX(-50%) scaleX(1);
				}
			}
		}
	}

	.tabcontent {
		padding: 1rem;
		flex: 1;
		display: flex;
		flex-direction: column;
	}
}